import { buildProps } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type Drawer from './drawer.vue'
export const drawerOptions = {
  destroyOnClose: true,
  width: '560px',
  keyboard: false,
  maskClosable: false,
  mask: true,
}
export const drawerProps = buildProps({
  /**
   * @description 开启抽屉
   */
  open: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 标题
   */
  title: {
    type: String,
    default: '新增',
  },
  /**
   * @description 加载状态
   */
  loading: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 确认按钮文字
   */
  confirmText: {
    type: String,
    default: '确认',
  },
  /**
   * @description 取消按钮文字
   */
  cancelText: {
    type: String,
    default: '取消',
  },
  /**
   * @description 显示取消按钮
   */
  showCancel: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 显示底部
   */
  showFooter: {
    type: Boolean,
    default: true,
  },
  /**
   * @description 区分关闭与取消方法
   */
  useClose: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 显示取消二次确认
   */
  cancelConfirm: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 二次确认属性
   */
  cancelConfirmOptions: {
    type: Object,
    default: null,
  },
  /**
   * @description 是否使用esc关闭
   */
  keyboard: {
    type: Boolean,
    default: true,
  },
} as const)

export const drawerEmits = {
  /**
   * @description 点击取消时触发
   */
  cancel: () => true,
  /**
   * @description 点击确认时触发
   */
  confirm: () => true,
  /**
   * @description 抽屉关闭时触发
   */
  close: () => true,
  'update:open': () => true,
} as const

// props
export type DrawerProps = ExtractPropTypes<typeof drawerProps>

// emits
export type DrawerEmits = typeof drawerEmits

// instance
export type DrawerInstance = InstanceType<typeof Drawer>
